import React, { Component } from 'react';
// import styled from 'styled-components';

import { render } from 'react-dom'
import { Button, Form, Icon, Modal} from 'semantic-ui-react'


// const FormEnter = props => {
class FormEnter extends Component {

    constructor(props){

      super(props)
      this.state={
          loginFormDraw:this.props.loginFormDraw,
      }
    }
render(){
  const {loginFormDraw} = this.state
  return (
    <div>
        <a href={null} style={{'position':'relative', 'top':'-2px', 'pointer':'cursor'}} onClick={()=>this.setState({loginFormDraw:true})}>Войти</a>
          <Modal open={loginFormDraw}   basic size='small'>
            <Modal.Content>

              <Form>
                <label>Логин:</label>
                  <input type="text" />
                  <label>Пароль:</label>
                  <input type="password"/>
                  <div style={{'padding': '12px', 'text-align':'center'}}>
                      <a href={null} onClick={()=>this.setState({loginFormDraw:false})}> close </a>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Button color='green' inverted>
                        <Icon name='checkmark' /> Войти
                      </Button>
                  </div>
              </Form>
            </Modal.Content>

          </Modal>

    </div>


);
}

};

export default FormEnter;
